import { TODAY } from '../../constants';
import { resolveUpdate } from './resolve';

export const createJiraSlice = (set) => ({
  jiraData: {
    byEpic: {},
    byProject: {},
    byProjectMonth: {},
    loading: false,
    error: null,
    lastSync: null,
  },
  setJiraData: (suivant) => set((etat) => ({ jiraData: resolveUpdate(suivant, etat.jiraData) })),
  maintenanceLabelHours: {}, // { [phaseId]: heures par label Jira, voir handlers/jira/labelHours }
  setMaintenanceLabelHours: (suivant) =>
    set((etat) => ({ maintenanceLabelHours: resolveUpdate(suivant, etat.maintenanceLabelHours) })),
  hoursByBrick: {}, // { [briqueId]: heures totales (tous users) }
  setHoursByBrick: (suivant) =>
    set((etat) => ({ hoursByBrick: resolveUpdate(suivant, etat.hoursByBrick) })),
  hoursByBrickAndDev: {}, // { [briqueId]: { [devId]: heures } }
  setHoursByBrickAndDev: (suivant) =>
    set((etat) => ({ hoursByBrickAndDev: resolveUpdate(suivant, etat.hoursByBrickAndDev) })),
  jiraEpicsModal: null, // { projetId, epics:[{key,summary}], selected:Set }
  setJiraEpicsModal: (suivant) =>
    set((etat) => ({ jiraEpicsModal: resolveUpdate(suivant, etat.jiraEpicsModal) })),
  jiraEpicsLoading: false,
  setJiraEpicsLoading: (suivant) =>
    set((etat) => ({ jiraEpicsLoading: resolveUpdate(suivant, etat.jiraEpicsLoading) })),
  yearImportModal: null, // null | { loading, done, total, current } | { result, inserted, skipped, unmatched }
  setYearImportModal: (suivant) =>
    set((etat) => ({ yearImportModal: resolveUpdate(suivant, etat.yearImportModal) })),
  jiraImportLogs: [],
  setJiraImportLogs: (suivant) =>
    set((etat) => ({ jiraImportLogs: resolveUpdate(suivant, etat.jiraImportLogs) })),
  jiraSyncHealth: null, // null | { last_success_at, last_error_at, last_error_message, last_error_project }
  setJiraSyncHealth: (suivant) =>
    set((etat) => ({ jiraSyncHealth: resolveUpdate(suivant, etat.jiraSyncHealth) })),
  jiraHealthDismissedAt: null, // last_error_at déjà vu/masqué par l'utilisateur
  setJiraHealthDismissedAt: (suivant) =>
    set((etat) => ({ jiraHealthDismissedAt: resolveUpdate(suivant, etat.jiraHealthDismissedAt) })),
  jiraAuthorsModal: null, // null | { loading } | { authors:[...] }
  setJiraAuthorsModal: (suivant) =>
    set((etat) => ({ jiraAuthorsModal: resolveUpdate(suivant, etat.jiraAuthorsModal) })),
  logResolutions: {}, // { [logId]: { clientId: string, briqueId: string } }
  setLogResolutions: (suivant) =>
    set((etat) => ({ logResolutions: resolveUpdate(suivant, etat.logResolutions) })),
  jiraAdminTab: 'auteurs', // 'auteurs' | 'logs'
  setJiraAdminTab: (suivant) =>
    set((etat) => ({ jiraAdminTab: resolveUpdate(suivant, etat.jiraAdminTab) })),
  syncYear: TODAY.getFullYear(),
  setSyncYear: (suivant) => set((etat) => ({ syncYear: resolveUpdate(suivant, etat.syncYear) })),
  epicImportQueue: [], // file de phases forfait_brique à proposer pour import d'Epics après conversion
  setEpicImportQueue: (suivant) =>
    set((etat) => ({ epicImportQueue: resolveUpdate(suivant, etat.epicImportQueue) })),
  epicMonthOpen: {}, // { [`${phaseId}|${month}`]: true } mois déplié (maintenance)
  setEpicMonthOpen: (suivant) =>
    set((etat) => ({ epicMonthOpen: resolveUpdate(suivant, etat.epicMonthOpen) })),
  epicMonthCache: {}, // { [`${phaseId}|${month}`]: { byEpic, total } | 'loading' | 'error' }
  setEpicMonthCache: (suivant) =>
    set((etat) => ({ epicMonthCache: resolveUpdate(suivant, etat.epicMonthCache) })),
});
